import Axios from "axios"


export async function get_apply_list(props) {
    const student_name = props['student_name']
    const parent_phone = props['parent_phone']
    const Set_applyList = props['Set_applyList']

    const result = await Axios
                    .post("/consumer/inquiry", {
                        student_name: student_name,
                        parent_phone: parent_phone
                    })
    const data = result['data']

    if(Set_applyList) {
        Set_applyList(data['data'])
    }

    return data
}